<template>
  <div>
    <v-row>
      <v-col :cols="3" style="color:#9e9e9e;">设备名称</v-col>
      <v-col :cols="9">
        <span>{{deviceInfo.DEV_TEXT}}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="3" style="color:#9e9e9e;">客户名称</v-col>
      <v-col :cols="9">
        <span>{{pollingInfo.COMPANY_NAME}}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="3" style="color:#9e9e9e;">联系人</v-col>
      <v-col :cols="9">
        <span>{{pollingInfo.CONT_NAME}}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="3" style="color:#9e9e9e;">联系电话</v-col>
      <v-col :cols="9">
        <span>{{pollingInfo.CONT_TEL}}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="3" style="color:#9e9e9e;">邮箱</v-col>
      <v-col :cols="9">
        <span>{{pollingInfo.CONT_EMAIL}}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="3" style="color:#9e9e9e;">时间</v-col>
      <v-col :cols="9">
        <span>{{$moment(recordInfo.EVENT_TIME).format("YYYY-MM-DD HH:mm:ss")}}</span>
      </v-col>
    </v-row>
    <div style="margin:auto;margin-top:1rem;text-align:center;">
      <div>
        <!-- <v-btn large class="secondary us-btn-style" @click="download">下载附件</v-btn> -->
        <v-btn
          v-if="downloadUrl"
          large
          class="secondary us-btn-style"
          v-clipboard:copy="downloadUrl"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError">
          复制链接
        </v-btn>
        <v-btn
          v-else
          large
          class="secondary us-btn-style"
          disabled>
          文件已失效
        </v-btn>
      </div>
      <div style="margin-top: 10px;">
        <span>微信不支持文件下载</span>
        <br/>
        <span>请复制链接去浏览器下载附件 (仅5分钟内有效)</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    deviceInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    pollingInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    recordInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    notifyInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    activated: {
      type: Boolean,
      default: false
    },
    downloadUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      message: '123456'
    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
  },
  methods: {
    download() {
      var that = this
      var code = that.pollingInfo.POLL_CODE
      if (!code) {
        that.$toast.warning('文件不存在')
      }
      window.open(that.$api.aishu.downloadPollingFileByCode(code))
    },
    onCopy(e) {
      var that = this
      that.$toast.success('链接复制成功')
    },
    onError(e) {
      var that = this
      console.log(e)
      that.$toast.error('链接复制失败')
    },
    // 时间格式化
    getTimeStr(sec) {
      var strDura = ''
      var dura = 0
      if (sec >= 86400) {
        dura = Number.parseInt(sec / 60 / 60 / 24);
        strDura = dura + ' 天';
      } else if (sec >= 3600) {
        dura = Number.parseInt(sec / 60 / 60);
        strDura = dura + ' 小时';
      } else if (sec >= 60) {
        dura = Number.parseInt(sec / 60);
        strDura = dura + ' 分钟';
      } else {
        strDura = dura + ' 秒';
      }
      return strDura
    },
    replaceSymbol(v) {
      if (!v) {
        return ''
      }
      v = v.replace(/\n/g, '<br />')
      return v
    }
  }
}
</script>

<style scoped>
.secondary {
    background-color: #5cbbf6 !important;
    border-color: #5cbbf6 !important;
}
.us-btn-style {
  font-size: 16px;
  width: 90%;
  font-weight: bold;
  margin-top: 1.1rem;
  text-align: center;
}
</style>
